// Utility function to check if the feature is enabled
// Currently using this feature flag for subscription/customer data
export async function isFeatureEnabled({ organizationId, t }) {
  if (!organizationId) {
    const organization = await t.organization("id");
    organizationId = organization.id;
  }
  //return organizationId === process.env.FEATURE_FLAG_ORGANIZATION_ID; // Enable this to enable the feature for my specific organization
  return false; // False to disable the feature
  //return true; // True to enable the feature
}
